exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*  JQUERY UI */\r\n.ui-sortable-placeholder {\r\n    border-color: #f2f4f8 !important;\r\n    visibility: visible !important;\r\n    background-size: 30px 30px;\r\n    background-image: linear-gradient(-45deg, #f2f4f8 25%, transparent 25%, transparent 50%, #f2f4f8 50%, #f2f4f8 75%, transparent 75%, transparent);\r\n    animation: ui-placeholder-stripes 2s linear infinite;\r\n}\r\n\r\n@keyframes ui-placeholder-stripes {\r\n    from {\r\n        background-position: 0 0;\r\n    }\r\n    to {\r\n        background-position: 60px 30px;\r\n    }\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./src/assets/modules/vendors/jquery-ui/jquery-ui.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/index.js?{"ident":"postcss"}!./src/assets/modules/vendors/jquery-ui/jquery-ui.css
// module chunks = 3